module.exports = __webpack_public_path__ + "img/logo.063aef84.png";